var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203.495,
    height: 179.19,
    viewBox: "0 0 203.495 179.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(-69.037 -95.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, 69.03, 165.105)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 166.926,
    height: 115.51,
    rx: 40,
    transform: "translate(0 0.023)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_20",
    "data-name": "Subtraction 20",
    d: "M121.779,58.071H34.9A40.211,40.211,0,0,1,25.687,57a39.784,39.784,0,0,1-8.455-3.038A40.152,40.152,0,0,1,3.581,42.952L53.015,0,78.34,22.006,103.667,0,153.1,42.952a40.159,40.159,0,0,1-13.651,11.014A39.788,39.788,0,0,1,130.995,57,40.207,40.207,0,0,1,121.779,58.071Z",
    transform: "translate(5.442 57.459)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_8",
    "data-name": "Intersection 8",
    d: "M3.273,18.951A39.978,39.978,0,0,1,37.294,0h86.877a39.977,39.977,0,0,1,34.02,18.951L80.733,86.188Z",
    transform: "translate(3.05 0)",
    fill: "#FF6600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, 78.081, 147.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.926,
    height: 115.51,
    rx: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 158.926,
    height: 107.51,
    rx: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_19",
    "data-name": "Subtraction 19",
    transform: "translate(4.803 57.463)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.779,58.071H34.9A40.211,40.211,0,0,1,25.687,57a39.784,39.784,0,0,1-8.455-3.038A40.152,40.152,0,0,1,3.581,42.952L53.015,0,78.34,22.006,103.667,0,153.1,42.952a40.159,40.159,0,0,1-13.651,11.014A39.788,39.788,0,0,1,130.995,57,40.207,40.207,0,0,1,121.779,58.071Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 121.7790298461914 50.07072067260742 C 124.2747650146484 50.07072067260742 126.7576370239258 49.78366851806641 129.1585845947266 49.21755981445313 C 131.4890289306641 48.66803359985352 133.7608184814453 47.85174560546875 135.9109191894531 46.79132461547852 C 137.8389129638672 45.84050369262695 139.6762542724609 44.69013214111328 141.3808746337891 43.36712646484375 L 103.6672821044922 10.59781169891357 L 83.58760833740234 28.04477310180664 L 78.34047698974609 32.60393142700195 L 73.09336853027344 28.04474639892578 L 53.01456069946289 10.5983362197876 L 15.30081748962402 43.36737823486328 C 17.00539016723633 44.69038772583008 18.84273719787598 45.84073257446289 20.77092361450195 46.79164123535156 C 22.9210033416748 47.85198211669922 25.1927661895752 48.66819381713867 27.52302932739258 49.21758651733398 C 29.92416000366211 49.78369140625 32.40710830688477 50.07072067260742 34.90289688110352 50.07072067260742 L 121.7790298461914 50.07072067260742 M 121.7790298461914 58.07072067260742 L 34.90289688110352 58.07072067260742 C 31.78976631164551 58.07072067260742 28.68918609619141 57.71185302734375 25.68726539611816 57.00411605834961 C 22.76897621154785 56.31608963012695 19.92439651489258 55.29411315917969 17.23252868652344 53.96658706665039 C 14.58884429931641 52.66282653808594 12.0822925567627 51.05966567993164 9.782528877258301 49.20158767700195 C 7.496634006500244 47.35472106933594 5.410186767578125 45.25219345092773 3.58110785484314 42.95248413085938 L 53.01457977294922 0.0002985269529744983 L 78.34049987792969 22.00590324401855 L 103.6673202514648 -0.0002277888270327821 L 153.1007995605469 42.95248413085938 C 151.2706146240234 45.2534294128418 149.18408203125 47.35532379150391 146.8993682861328 49.20119476318359 C 144.599609375 51.05924606323242 142.0930480957031 52.66245651245117 139.4493713378906 53.96624755859375 C 136.7575073242188 55.29384994506836 133.9129028320313 56.31587600708008 130.99462890625 57.00400924682617 C 127.9927139282227 57.71182632446289 124.8921051025391 58.07072067260742 121.7790298461914 58.07072067260742 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_4",
    "data-name": "Intersection 4",
    transform: "translate(2.411 0.004)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.843,19.661A39.985,39.985,0,0,1,37.294,0h86.877a39.978,39.978,0,0,1,34.45,19.661L80.733,91.211Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.294189453125 8.000007629394531 C 28.18177795410156 8.000007629394531 19.52656555175781 11.94815826416016 13.51239013671875 18.59832000732422 L 80.73269653320313 80.34827423095703 L 147.9530944824219 18.59830474853516 C 141.9398040771484 11.94827270507813 133.2844543457031 8.000007629394531 124.1711883544922 8.000007629394531 L 37.294189453125 8.000007629394531 M 37.294189453125 7.62939453125e-06 L 124.1711883544922 7.62939453125e-06 C 138.8372192382813 7.62939453125e-06 151.6587829589844 7.8914794921875 158.6215515136719 19.66117095947266 L 80.73268890380859 91.21139526367188 L 2.84344482421875 19.66072845458984 C 9.806915283203125 7.892814636230469 22.62953186035156 7.62939453125e-06 37.294189453125 7.62939453125e-06 Z",
    stroke: "none",
    fill: "#000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.cf1bf7891a0284d5feb5445fe478b763.svg";
export { ForwardRef as ReactComponent };